module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "review",
    style: (_vm.backgroundStyle)
  }, [_c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Название компании"
    },
    on: {
      "change": function($event) {
        return _vm.updateReview(_vm.review)
      }
    },
    model: {
      value: (_vm.review.title),
      callback: function($$v) {
        _vm.$set(_vm.review, "title", $$v)
      },
      expression: "review.title"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Ссылка на видео"
    },
    on: {
      "change": function($event) {
        return _vm.updateReview(_vm.review)
      }
    },
    model: {
      value: (_vm.review.video),
      callback: function($$v) {
        _vm.$set(_vm.review, "video", $$v)
      },
      expression: "review.video"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Краткое описание деятельности",
      "type": "textarea",
      "height": "80px"
    },
    on: {
      "change": function($event) {
        return _vm.updateReview(_vm.review)
      }
    },
    model: {
      value: (_vm.review.description),
      callback: function($$v) {
        _vm.$set(_vm.review, "description", $$v)
      },
      expression: "review.description"
    }
  })], 1), _vm._v(" "), _c('b-field', [_c('b-input', {
    attrs: {
      "placeholder": "Опишите результат сотрудничества",
      "type": "textarea",
      "height": "80"
    },
    on: {
      "change": function($event) {
        return _vm.updateReview(_vm.review)
      }
    },
    model: {
      value: (_vm.review.result),
      callback: function($$v) {
        _vm.$set(_vm.review, "result", $$v)
      },
      expression: "review.result"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('span', {
    staticClass: "button-wrapper",
    on: {
      "click": _vm.handleLoadReviewPhoto
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v("Загрузить фото")])]), _vm._v(" "), _c('input', {
    ref: "loadPhotoButton",
    attrs: {
      "type": "file",
      "id": "photo",
      "hidden": ""
    },
    on: {
      "change": _vm.loadPhoto
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "button-wrapper",
    on: {
      "click": function($event) {
        return _vm.deleteReview(_vm.review.id)
      }
    }
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    }
  }), _vm._v("\n    Удалить отзыв с описанием и видео\n  ")])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70928112"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Services/Review.vue
// module id = 966
// module chunks = 0